// extracted by mini-css-extract-plugin
export default {"calendar":"K9K5WU","mobile":"zOG_9Y"};